import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import PaginationControls from '../common/PaginationControls'
import {
  selectCloneLeaguesSessionsPagination,
  fetchCloneLeaguesSessionsMergedParams,
  setPageCloneLeaguesSessions,
} from '../../reducers/clone_leagues_sessions'

const MAX_DISPLAYED_PAGES = 5

const SessionsPagination = () => {
  const dispatch = useDispatch()
  const pagination = useSelector(selectCloneLeaguesSessionsPagination)
  const { page: currentPage, totalPages } = pagination

  const handlePageChange = useCallback((page) => {
    if (page < 1 || page > totalPages) {
      return
    }
    dispatch(setPageCloneLeaguesSessions(page))
    dispatch(fetchCloneLeaguesSessionsMergedParams())
  }, [ pagination ])

  return <PaginationControls
      currentPage={currentPage}
      totalPages={totalPages}
      handlePageChange={handlePageChange}
      maxDisplayedPages={MAX_DISPLAYED_PAGES}
  />
}

export default SessionsPagination
